var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "95321B0D-82AD-415A-B4E0-3F459EB77CF4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inicio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-241.000000, -1240.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    id: "Group-8",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.000000, 897.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "saber_mas_boton",
    transform: "translate(0.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.052134,20.2423325 C166.391685,20.5721818 166.39955,21.1148376 166.069701,21.4543883 L161.222,26.444 L175.480706,26.4440132 C175.954093,26.4440132 176.337849,26.8277691 176.337849,27.3011561 C176.337849,27.774543 175.954093,28.1582989 175.480706,28.1582989 L161.222,28.158 L166.069701,33.1479238 C166.39955,33.4874745 166.391685,34.0301303 166.052134,34.3599796 C165.712584,34.6898288 165.169928,34.6819642 164.840079,34.3424136 L158.676878,27.9979417 C158.299917,27.6098938 158.299917,26.9924183 158.676878,26.6043704 L164.840079,20.2598985 C165.169928,19.9203479 165.712584,19.9124833 166.052134,20.2423325 Z",
    id: "icon-back",
    transform: "translate(167.168924, 27.301156) rotate(-180.000000) translate(-167.168924, -27.301156) "
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-back.23cdddab.svg";
export { ForwardRef as ReactComponent };